export default __webpack_public_path__ + "static/media/api-image-yunji.9b4b1433.jpg";